var _style, _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUmbrella(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250",
    width: 250,
    height: 250,
    preserveAspectRatio: "xMidYMid meet",
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0px, 0px, 0px)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n    @keyframes flicker {\r\n      0% { \r\n        transform: scale(1);\r\n      }\r\n      50% { \r\n        transform: scale(1.5);\r\n      }\r\n      100% { \r\n        transform: scale(1);\r\n      }\r\n    }\r\n\r\n    @keyframes floating {\r\n      0% {\r\n        transform: translateY(0);\r\n      }\r\n      50% {\r\n        transform: translateY(25px);\r\n      }\r\n      100% {\r\n        transform: translateY(0);\r\n      }\r\n    }\r\n\r\n    @keyframes raindrop {\r\n      0% {\r\n        display: block !important;\r\n        transform: translateY(0px);\r\n      }\r\n      50% {\r\n        display: block !important;\r\n        transform: translateY(25px);\r\n      }\r\n      100% {\r\n        display: block !important;\r\n        transform: translateY(3px);\r\n        opacity: 0;\r\n      }\r\n    }\r\n\r\n    .small-star {\r\n      animation: flicker 2s infinite;\r\n    }\r\n\r\n    .large-star {\r\n      animation: flicker 2.5s infinite;\r\n    }\r\n\r\n    .umbrella {\r\n      animation: floating 3s infinite ease-in-out;\r\n    }\r\n\r\n    .raindrop {\r\n      width: 50px;\r\n      height: 100px;\r\n      opacity: 1;\r\n      display: block !important;\r\n      animation: raindrop 2s infinite;\r\n    }\r\n\r\n    .raindrop-fast {\r\n      animation: raindrop 1s infinite;\r\n    }\r\n\r\n    .raindrop-slow {\r\n      animation: raindrop 1.5s infinite;\r\n    }\r\n\r\n    .raindrop-medium {\r\n      animation: raindrop 1.25s infinite;\r\n    }\r\n\r\n    .raindrop-super-slow {\r\n      animation: raindrop 1.75s infinite;\r\n    }\r\n\r\n  ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    x: 0,
    y: 0
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,119.08100128173828,54.93103790283203)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,22.916000366210938,85.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "umbrella",
    fill: "rgb(222,228,248)",
    fillOpacity: 1,
    d: " M-11.333000183105469,-79.33300018310547 C-11.333000183105469,-82.46299743652344 -13.869999885559082,-85 -16.999000549316406,-85 C-20.128999710083008,-85 -22.66699981689453,-82.46299743652344 -22.66699981689453,-79.33300018310547 C-22.66699981689453,-79.33300018310547 -22.66699981689453,62.33300018310547 -22.66699981689453,62.33300018310547 C-22.66699981689453,74.83200073242188 -12.498000144958496,85 0.0010000000474974513,85 C12.49899959564209,85 22.66699981689453,74.83200073242188 22.66699981689453,62.33300018310547 C22.66699981689453,62.33300018310547 22.66699981689453,56.66699981689453 22.66699981689453,56.66699981689453 C22.66699981689453,53.5369987487793 20.1299991607666,51 17.000999450683594,51 C13.871000289916992,51 11.333000183105469,53.5369987487793 11.333000183105469,56.66699981689453 C11.333000183105469,56.66699981689453 11.333000183105469,62.33300018310547 11.333000183105469,62.33300018310547 C11.333000183105469,68.58200073242188 6.25,73.66600036621094 0.0010000000474974513,73.66600036621094 C-6.249000072479248,73.66600036621094 -11.333000183105469,68.58200073242188 -11.333000183105469,62.33300018310547 C-11.333000183105469,62.33300018310547 -11.333000183105469,-79.33300018310547 -11.333000183105469,-79.33300018310547z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,39.74400329589844,66.2640380859375)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,85.25299835205078,42.75)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "umbrella",
    fill: "rgb(155,171,217)",
    fillOpacity: 1,
    d: " M-28.333999633789062,42.5 C-27.881000518798828,42.49599838256836 -27.461999893188477,42.26900100708008 -27.201000213623047,41.89799880981445 C-21.488000869750977,33.762001037597656 -11.8149995803833,28.33300018310547 -0.003000000026077032,28.33300018310547 C-0.003000000026077032,28.33300018310547 -0.0010000000474974513,28.33300018310547 -0.0010000000474974513,28.33300018310547 C11.810999870300293,28.33300018310547 21.485000610351562,33.762001037597656 27.19700050354004,41.89799880981445 C27.458999633789062,42.27000045776367 27.878999710083008,42.49700164794922 28.33300018310547,42.5 C28.33300018310547,-4.443999767303467 15.64900016784668,-42.5 0.0010000000474974513,-42.5 C-15.647000312805176,-42.5 -28.333999633789062,-4.443999767303467 -28.333999633789062,42.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,42.750999450683594,42.75)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "umbrella",
    fill: "rgb(187,200,236)",
    fillOpacity: 1,
    d: " M-42.49700164794922,41.569000244140625 C-42.50199890136719,42.082000732421875 -42.08399963378906,42.5 -41.571998596191406,42.5 C-41.266998291015625,42.5 -40.98500061035156,42.347999572753906 -40.8120002746582,42.09700012207031 C-35.13999938964844,33.849998474121094 -26.09000015258789,28.333999633789062 -14.182000160217285,28.333999633789062 C-2.371000051498413,28.333999633789062 7.302999973297119,33.76100158691406 13.015999794006348,41.89799880981445 C13.277999877929688,42.27199935913086 13.701000213623047,42.5 14.157999992370605,42.5 C14.157999992370605,42.5 14.166999816894531,42.486000061035156 14.166999816894531,42.486000061035156 C14.170000076293945,-4.451000213623047 26.854999542236328,-42.5 42.500999450683594,-42.5 C42.500999450683594,-42.5 42.499000549316406,-42.5 42.499000549316406,-42.5 C-4.135000228881836,-42.5 -41.99800109863281,-4.946000099182129 -42.49700164794922,41.569000244140625z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,127.75299835205078,42.75)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "umbrella",
    fill: "rgb(187,200,236)",
    fillOpacity: 1,
    d: " M-42.5,-42.5 C-26.85300064086914,-42.5 -14.168000221252441,-4.448999881744385 -14.166999816894531,42.4900016784668 C-14.166999816894531,42.4900016784668 -14.15999984741211,42.5 -14.15999984741211,42.5 C-13.70300006866455,42.5 -13.279999732971191,42.27199935913086 -13.017000198364258,41.89799880981445 C-7.304999828338623,33.762001037597656 2.36899995803833,28.333999633789062 14.180000305175781,28.333999633789062 C26.08799934387207,28.333999633789062 35.13800048828125,33.85100173950195 40.810001373291016,42.097999572753906 C40.981998443603516,42.347999572753906 41.26499938964844,42.5 41.569000244140625,42.5 C42.082000732421875,42.5 42.5,42.082000732421875 42.49399948120117,41.569000244140625 C41.994998931884766,-4.946000099182129 4.132999897003174,-42.5 -42.5,-42.5z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,211,75)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "raindrop raindrop-slow",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(222,228,248)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M2,2 C2,2 2,8 2,8"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,199,102)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "raindrop raindrop-super-slow",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(222,228,248)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M2,2 C2,2 2,6 2,6"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,178,88)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "raindrop raindrop-slow",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(222,228,248)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M2,2 C2,2 2,8 2,8"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,162,62)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "raindrop raindrop-super-slow",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(222,228,248)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M2,2 C2,2 2,12 2,12"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,147,84)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "raindrop raindrop-fast",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(222,228,248)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M2,2 C2,2 2,6 2,6"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,131,59)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "raindrop raindrop-super-slow",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(222,228,248)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M2,2 C2,2 2,8 2,8"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,89,100)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "raindrop raindrop-fast",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(222,228,248)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M2,2 C2,2 2,6 2,6"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,104,69)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "raindrop raindrop-medium",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(222,228,248)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M2,2 C2,2 2,12 2,12"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,93,54)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "raindrop raindrop-fast",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(222,228,248)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M2,2 C2,2 2,6 2,6"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,73,84)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "raindrop raindrop-super-slow",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(222,228,248)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M2,2 C2,2 2,8 2,8"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,52,96)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "raindrop raindrop-medium",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(222,228,248)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M2,2 C2,2 2,12 2,12"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,211,75)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "raindrop raindrop-slow",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(222,228,248)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M2,2 C2,2 2,8 2,8"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,199,102)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "raindrop raindrop-medium",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(222,228,248)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M2,2 C2,2 2,6 2,6"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,178,88)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "raindrop raindrop-super-slow",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(222,228,248)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M2,2 C2,2 2,8 2,8"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,162,62)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "raindrop raindrop-slow",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(222,228,248)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M2,2 C2,2 2,12 2,12"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,147,84)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "raindrop raindrop-super-slow",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(222,228,248)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M2,2 C2,2 2,6 2,6"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,131,59)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "raindrop raindrop-medium",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(222,228,248)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M2,2 C2,2 2,8 2,8"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,89,100)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "raindrop raindrop-slow",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(222,228,248)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M2,2 C2,2 2,6 2,6"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,104,68.94056701660156)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "raindrop raindrop-fast",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(222,228,248)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M2,2 C2,2 2,12 2,12"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,93,54)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "raindrop raindrop-super-slow",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(222,228,248)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M2,2 C2,2 2,6 2,6"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,73,84)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "raindrop raindrop-medium",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(222,228,248)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M2,2 C2,2 2,8 2,8"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,52,96)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "raindrop raindrop-fast",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(222,228,248)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M2,2 C2,2 2,12 2,12"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5714160799980164,0,0,0.5714160799980164,186.7144012451172,21.928693771362305)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,9.25,9.75)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "small-star",
    fill: "rgb(155,171,217)",
    fillOpacity: 1,
    d: " M8.182000160217285,-0.8640000224113464 C4.107999801635742,-0.8640000224113464 0.8190000057220459,-4.335999965667725 0.8190000057220459,-8.63599967956543 C0.8190000057220459,-9.119999885559082 0.4580000042915344,-9.5 0,-9.5 C-0.4580000042915344,-9.5 -0.8180000185966492,-9.119999885559082 -0.8180000185966492,-8.63599967956543 C-0.8180000185966492,-4.335999965667725 -4.10699987411499,-0.8640000224113464 -8.180999755859375,-0.8640000224113464 C-8.638999938964844,-0.8640000224113464 -9,-0.48399999737739563 -9,0 C-9,0.4830000102519989 -8.638999938964844,0.8640000224113464 -8.180999755859375,0.8640000224113464 C-4.10699987411499,0.8640000224113464 -0.8180000185966492,4.335000038146973 -0.8180000185966492,8.63599967956543 C-0.8180000185966492,9.119999885559082 -0.4580000042915344,9.5 0,9.5 C0.4580000042915344,9.5 0.8190000057220459,9.119999885559082 0.8190000057220459,8.63599967956543 C0.8190000057220459,4.335000038146973 4.107999801635742,0.8640000224113464 8.182000160217285,0.8640000224113464 C8.640000343322754,0.8640000224113464 9,0.4830000102519989 9,0 C9,-0.48399999737739563 8.640000343322754,-0.8640000224113464 8.182000160217285,-0.8640000224113464z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,30.749000549316406,24.751001358032227)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,13.345000267028809,13.343999862670898)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "large-star",
    fill: "rgb(222,228,248)",
    fillOpacity: 1,
    d: " M11.904000282287598,-1.190999984741211 C5.97599983215332,-1.190999984741211 1.190999984741211,-5.97599983215332 1.190999984741211,-11.904000282287598 C1.190999984741211,-12.569999694824219 0.6679999828338623,-13.093999862670898 0.0010000000474974513,-13.093999862670898 C-0.6660000085830688,-13.093999862670898 -1.1890000104904175,-12.569999694824219 -1.1890000104904175,-11.904000282287598 C-1.1890000104904175,-5.97599983215332 -5.97599983215332,-1.190999984741211 -11.904000282287598,-1.190999984741211 C-12.571000099182129,-1.190999984741211 -13.093999862670898,-0.6679999828338623 -13.093999862670898,-0.0010000000474974513 C-13.093999862670898,0.6660000085830688 -12.571000099182129,1.190999984741211 -11.904000282287598,1.190999984741211 C-5.97599983215332,1.190999984741211 -1.1890000104904175,5.97599983215332 -1.1890000104904175,11.904000282287598 C-1.1890000104904175,12.571000099182129 -0.6660000085830688,13.093999862670898 0.0010000000474974513,13.093999862670898 C0.6679999828338623,13.093999862670898 1.190999984741211,12.571000099182129 1.190999984741211,11.904000282287598 C1.190999984741211,5.97599983215332 5.97599983215332,1.190999984741211 11.904000282287598,1.190999984741211 C12.571000099182129,1.190999984741211 13.093999862670898,0.6660000085830688 13.093999862670898,-0.0010000000474974513 C13.093999862670898,-0.6679999828338623 12.571000099182129,-1.190999984741211 11.904000282287598,-1.190999984741211z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmbrella);
export default __webpack_public_path__ + "static/media/umbrella.e5e2cf747d320832de48ebb5e2578974.svg";
export { ForwardRef as ReactComponent };